module.exports = __webpack_public_path__ + "img/2d70be86c03939b98f8efff3c5332aa0.2d70be86.png";